import React from "react";
import Grid from "@material-ui/core/Grid";
import FriendsMediaCard from "components/Project/StartProject/Step_3/FriendsCard";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import ArrowBackIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";
import TextTheme from "components/General/Text/TextTheme";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import "App.css";
import * as CONSTANT from "constants/text";
import { withStyles } from "@material-ui/core/styles";
import MuiDialog from "@material-ui/core/Dialog";

const CustomDialog = withStyles((theme) => ({
  paper: {
    borderRadius: "10px",
    padding: "8px",
    backgroundColor: "#1a3867",
  },
}))(MuiDialog);

class FriendsSearchGrid extends React.Component {
  searchResultImageClick(value) {
    this.props.searchResultImageClick(value);
  }
  searchResultViewClick(value) {
    this.props.searchResultViewClick(value);
  }

  render() {
    return (
      <div>
        <CustomDialog
          open={true}
          maxWidth={"md"}
          fullWidth={"md"}
          scroll={"body"}
          className={
            this.props.searchData.length > 0 ? null : "no-search-results"
          }
        >
          <div className="popup_search_text">
            <TextTheme
              message={
                this.props.searchStringValue !== ""
                  ? this.props.searchStringType === "Username"
                    ? "Search Result For User" +
                      ' : "' +
                      this.props.searchStringValue +
                      '"'
                    : "Search Result For " +
                      this.props.searchStringType +
                      ' : "' +
                      this.props.searchStringValue +
                      '"'
                  : this.props.searchStringType === "Username"
                  ? "Search Result For Users"
                  : "Search Result For " + this.props.searchStringType
              }
              className="text_medium text_white text_bold"
            />
          </div>
          <Grid
            container
            spacing={5}
            direction="row"
            justify="start"
            alignItems="start"
            style={{
              paddingLeft: "40px",
              paddingRight: "40px",
              paddingTop: "30px",
            }}
          >
            {this.props.searchData.length > 0 ? (
              this.props.searchData.map((elem) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  key={this.props.searchData.indexOf(elem)}
                >
                  {this.props.searchStringType === CONSTANT.USERNAME ? (
                    <FriendsMediaCard
                      key={elem.user_name}
                      imageSrc={elem.user_photo}
                      imageId={elem.user_name}
                      imageName={elem.user_name}
                      imageFullName={elem.full_name}
                      searchResultInviteClick={this.searchResultViewClick.bind(
                        this
                      )}
                      type={CONSTANT.FRIENDS}
                    />
                  ) : this.props.searchStringType === CONSTANT.NEW_MEMBERS ? (
                    <FriendsMediaCard
                      key={elem.user_name}
                      imageSrc={elem.user_photo}
                      imageId={elem.user_name}
                      imageName={elem.user_name}
                      imageFullName={elem.full_name}
                      searchResultInviteClick={this.searchResultViewClick.bind(
                        this
                      )}
                      type={CONSTANT.NEW_MEMBERS}
                      groupName={this.props.groupName}
                      groupID={this.props.groupID}
                    />
                  ) : this.props.searchStringType === CONSTANT.GROUPS ? (
                    <FriendsMediaCard
                      key={elem.id}
                      imageSrc={elem.group_pic}
                      imageId={elem.id}
                      imageName={elem.name}
                      searchResultInviteClick={this.searchResultViewClick.bind(
                        this
                      )}
                      type={CONSTANT.GROUPS}
                      groupName={elem.name}
                      groupID={elem.id}
                    />
                  ) : (
                    <FriendsMediaCard
                      key={elem.user_name}
                      imageSrc={elem.user_photo}
                      imageId={elem.user_email}
                      imageName={elem.user_name}
                      imageFullName={elem.full_name}
                      searchResultImageClick={this.searchResultImageClick.bind(
                        this
                      )}
                      type={CONSTANT.PROJECTS}
                    />
                  )}
                </Grid>
              ))
            ) : (
              <div className="text-center no-data-found">
                No results for {this.props.searchStringValue}
              </div>
            )}
          </Grid>

          <div className="popup_button_container">
            <div className="popup_back_next_button_container">
              <div>
                <RoundedButton
                  startIcon={
                    <ArrowBackIosRoundedIcon
                      style={
                        !this.props.searchLess
                          ? { color: "#8D8D8D", fontSize: "40" }
                          : { color: "white", fontSize: "40" }
                      }
                    />
                  }
                  handleOnClick={this.props.searchResultBackClick}
                  disabled={!this.props.searchLess}
                  height="35px"
                  title="Back"
                  textThemeClassName={
                    !this.props.searchLess
                      ? "text_medium text_light_med_grey text_bold"
                      : "text_medium text_white text_bold"
                  }
                  buttonClassName="background_dark_blue"
                  size="medium"
                  float="right"
                  borderRadius="6px"
                />
              </div>
              <div>
                <RoundedButton
                  endIcon={
                    <ArrowForwardIosRoundedIcon
                      style={
                        !this.props.searchMore
                          ? { color: "#8D8D8D", fontSize: "40" }
                          : { color: "white", fontSize: "40" }
                      }
                    />
                  }
                  handleOnClick={this.props.searchResultNextClick}
                  disabled={!this.props.searchMore}
                  height="35px"
                  title="Next"
                  textThemeClassName={
                    !this.props.searchMore
                      ? "text_medium text_light_med_grey text_bold"
                      : "text_medium text_white text_bold"
                  }
                  buttonClassName="background_dark_blue"
                  size="medium"
                  float="none"
                  borderRadius="6px"
                />
              </div>
            </div>
            <div className="popup_cancel_done_button_container">
              <RoundedButton
                handleOnClick={this.props.searchResultDoneClick}
                disabled={false}
                height="35px"
                title="&nbsp;&nbsp;&nbsp;Done&nbsp;&nbsp;&nbsp;"
                textThemeClassName="text_small text_white text_bold"
                buttonClassName="background_dark_orange"
                size="medium"
                borderRadius="6px"
              />

              <RoundedButton
                handleOnClick={this.props.searchResultCancelClick}
                height="35px"
                title="Cancel, maybe later"
                textThemeClassName="text_small text_white text_bold"
                borderRadius="6px"
              />
            </div>
          </div>
        </CustomDialog>
      </div>
    );
  }
}

export default FriendsSearchGrid;
